import { useState } from "react";
import { VoiceTextarea } from "../components/VoiceTextarea";

interface Props {
  onCancel: () => void;
  onSave: (title: string, rawCapture: string) => void | Promise<void>;
}

export function NewIdeaScreen(props: Props) {
  const [title, setTitle] = useState("");
  const [capture, setCapture] = useState("");
  const [saving, setSaving] = useState(false);

  const canSave = title.trim().length > 0 && !saving;

  const handleSave = async () => {
    if (!canSave) return;
    setSaving(true);
    try {
      await props.onSave(title.trim(), capture.trim());
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <header className="sticky top-0 z-10 flex items-center justify-between border-b border-black/5 bg-bg/90 px-4 py-3 backdrop-blur">
        <button className="btn-ghost" onClick={props.onCancel}>
          Cancel
        </button>
        <h1 className="text-lg font-semibold tracking-tight">New idea</h1>
        <span className="w-16" />
      </header>

      <main className="flex flex-1 flex-col gap-4 px-4 py-4">
        <p className="text-sm text-ink-muted">
          What's the idea? Just dump it — we'll sharpen it later.
        </p>
        <input
          className="input"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <VoiceTextarea
          value={capture}
          onChange={setCapture}
          placeholder="Who is it for? What problem? What have you tried? Just type or tap the mic."
          minHeightClass="min-h-[220px]"
          disabled={saving}
        />
        <button className="btn-primary mt-2" disabled={!canSave} onClick={handleSave}>
          {saving ? "Saving…" : "Save"}
        </button>
      </main>
    </>
  );
}
